import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../utils/api';

const inputStyle = {
  padding: '6px 10px',
  border: '1px solid var(--c-border-strong)',
  borderRadius: 6,
  fontSize: 14,
  fontWeight: 400,
};

const NEW_OPTION = '__new__';

// `title` replaces the generic tooltip where the caller knows which field
// this is (amplification vs sequencing primers share one category).
export default function ReferenceSelect({ category, value, onChange, placeholder, title }) {
  const { t } = useTranslation(['dna', 'common']);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get(`/dna/${category}`)
      .then(res => setOptions(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [category]);

  useEffect(() => { load(); }, [load]);

  const handleChange = (e) => {
    const selected = e.target.value;
    if (selected !== NEW_OPTION) {
      onChange(selected);
      return;
    }
    const name = window.prompt(t('addNewPrompt'));
    if (!name || !name.trim()) return;
    api.post(`/dna/${category}`, { name: name.trim() })
      .then(res => {
        load();
        onChange(res.data.id);
      })
      .catch(err => {
        if (err.response?.status === 409 && err.response.data?.id) {
          // Someone else already added this exact name — just select it.
          load();
          onChange(err.response.data.id);
          return;
        }
        window.alert(err.response?.data?.error || t('addNewFailed'));
      });
  };

  return (
    <select value={value || ''} onChange={handleChange} disabled={loading} style={inputStyle} title={title || t('tip.referenceSelect')}>
      <option value="">{placeholder || t('common:selectPlaceholder')}</option>
      {options.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
      <option value={NEW_OPTION}>{t('addNewOption')}</option>
    </select>
  );
}
